import { createContext, useCallback, useContext, useMemo, useState, type ReactNode } from 'react';

interface ToastState {
  message: string;
  show: (message: string) => void;
  dismiss: () => void;
}

const Ctx = createContext<ToastState>({ message: '', show: () => {}, dismiss: () => {} });

export function ToastProvider({ children }: { children: ReactNode }) {
  const [message, setMessage] = useState('');
  const show = useCallback((m: string) => setMessage(m), []);
  const dismiss = useCallback(() => setMessage(''), []);
  const value = useMemo(() => ({ message, show, dismiss }), [message, show, dismiss]);
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export function useToast(): ToastState {
  return useContext(Ctx);
}
